import { useEffect } from 'react';
import { SiteFooter, SiteHeader } from './SiteChrome';

export const Terms = () => {
  useEffect(() => {
    document.title = 'Terms of Use - Field Facts: Baseball';
  }, []);

  return (
    <div className="ff-page">
      <SiteHeader />
      <div className="ff-content ff-legal">
        <p className="ff-kicker">Legal</p>
        <h1>Terms of Use</h1>
        <p className="effective-date">Effective July 13, 2026</p>

        <p>
          Field Facts: Baseball is a community directory of baseball fields operated
          by Aeso, LLC. By using the app or website you agree to these terms.
        </p>

        <h2>The service</h2>
        <p>
          Field information is contributed by the community. We work to keep it useful,
          but we can't guarantee that details, ratings, or photos are accurate or
          current — always use your own judgment about a field's condition and safety.
          The service is provided "as is" without warranties, and our liability is
          limited to the maximum extent permitted by law.
        </p>

        <h2>Your content</h2>
        <ul>
          <li>You keep ownership of the photos and reviews you submit, and you grant us a worldwide, royalty-free license to host and display them as part of the directory.</li>
          <li>Only submit content you have the right to share, about real fields, based on your own experience.</li>
        </ul>

        <h2>Community rules</h2>
        <ul>
          <li>No objectionable content: nothing abusive, harassing, obscene, hateful, or unlawful, and no photos of identifiable people without their consent.</li>
          <li>No spam, advertising, or deliberately false field information.</li>
          <li>Use the in-app <strong>Report</strong> option to flag content that breaks these rules, and <strong>Block User</strong> to hide a contributor's content from your device. We review reports within 24 hours and remove content or ban accounts that violate these rules.</li>
        </ul>

        <h2>Accounts</h2>
        <p>
          You are responsible for activity on your account. We may suspend or remove
          accounts that violate these terms. You can delete your account at any time
          from the app menu; contributed directory content remains part of the
          community database.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about these terms:{' '}
          <a href="mailto:support@fieldfactsbaseball.com">support@fieldfactsbaseball.com</a>.
        </p>
      </div>
      <SiteFooter />
    </div>
  );
};
